module.exports = __webpack_public_path__ + "img/target001-1.9eb2bf74.png";